import {Component, Input, OnInit} from '@angular/core';
import {StoriaService} from '../service/storia.service';
import {AllegatoService} from '../service/allegato.service';
import {ActivatedRoute} from '@angular/router';
import {Storia} from '../model/storia';
import {ContenutoGenericoService} from '../service/contenuto-generico.service';
import {ContenutoGenerico} from '../model/contenuto-generico';
import {Search} from '../common/search';
import {SeoService} from '../service/seo.service';
import {DOCS_REPLACE} from '../constants/constants';

@Component({
    selector: 'app-storia',
    templateUrl: './storia.component.html',
})
export class StoriaComponent implements OnInit {

    @Input() element: ContenutoGenerico;

    public storiaList: Array<Storia>;
    public componentiCollegati: Array<ContenutoGenerico> = [];
    public loading = true;
    public lingua: string;

    slideConfig = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };


    constructor(private storiaService: StoriaService,
                private contenutoService: ContenutoGenericoService,
                private allegatoService: AllegatoService,
                private seoService: SeoService,
                public route: ActivatedRoute) {
    }

    ngOnInit() {
        this.lingua = this.element.lang;
        // this.seoService.addSeo(this.element);
        this.storiaService.search._sort = 'ordine ASC';
        this.storiaService.search._.lang = this.lingua;
        this.storiaService.getAllList().subscribe(storiaList => {
            this.storiaList = storiaList;
            if (this.storiaList) {
                for (const storia of this.storiaList) {
                    this.allegatoService.find(storia.immagine).subscribe(allegato => {
                        if (allegato) {
                            storia.path_immagine = DOCS_REPLACE(allegato.uuid);
                            this.seoService.setImage(storia.path_immagine);
                        }
                    });
                }
            }
            this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
            this.contenutoService.search._.contenitore = this.element.contenitore;
            this.contenutoService.search._sort = 'ordine ASC';
            this.contenutoService.search._.lang = this.lingua;
            this.contenutoService.getAllList().subscribe(componentiCollegati => {
                    for (const componente of componentiCollegati) {
                        this.componentiCollegati.push(componente);
                    }
                    this.loading = false;
                    this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                },
                err => {
                    this.loading = false;
                    this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                });
        });
    }

}
